// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2-urn","col":"styles_col__3OMnc"};